import { i18nKeys, I18nText as I18n } from '@gloat/glocalize';
import { ActionLink } from '@gloat/gig';

export default {
  RECAPTCHA_FAILURE: <I18n id={i18nKeys.RECAPTCHA_FAILURE} />,
  PROFICIENCY_UPDATED_SUCCESSFULLY: <I18n id={i18nKeys.PROFICIENCY_UPDATED_SUCCESSFULLY} />,
  AVAILABILITY_UPDATED_SUCCESSFULLY: <I18n id={i18nKeys.NOTIFICATIONS_AVAILABILITY_UPDATED_SUCCESSFULLY} />,
  CANDIDATE_SENT_MESSAGE_AFTER_ACCEPTED_MENTEE: name => (
    <I18n id={i18nKeys.NOTIFICATIONS_CANDIDATE_SENT_MESSAGE_AFTER_ACCEPTED_MENTEE} data={{ name }} />
  ),
  CANT_REACH: <I18n id={i18nKeys.NOTIFICATIONS_CANT_REACH} />,
  CANDIDATE_VIDEO_LARGE_FILE: size => <I18n id={i18nKeys.NOTIFICATIONS_CANDIDATE_VIDEO_LARGE_FILE} data={{ size }} />,
  CANDIDATE_VIDEO_DURATION_EXCEEDED: <I18n id={i18nKeys.NOTIFICATIONS_CANDIDATE_VIDEO_DURATION_EXCEEDED} />,
  CANDIDATE_VIDEO_UPLOAD_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_CANDIDATE_VIDEO_UPLOAD_SUCCESS} />,
  CANDIDATE_VIDEO_UPLOAD_FAILED: <I18n id={i18nKeys.NOTIFICATIONS_CANDIDATE_VIDEO_UPLOAD_FAILED} />,
  CANDIDATE_VIDEO_DELETE_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_CANDIDATE_VIDEO_DELETE_SUCCESS} />,
  CUSTOM: <I18n id={i18nKeys.NOTIFICATIONS_CUSTOM} />,
  DEFAULT: <I18n id={i18nKeys.NOTIFICATIONS_DEFAULT} />,
  EMAIL_ASSOCIATED: <I18n id={i18nKeys.NOTIFICATIONS_EMAIL_ASSOCIATED} />,
  EMAIL_EXISTS: <I18n id={i18nKeys.NOTIFICATIONS_EMAIL_EXISTS} />,
  EMAIL_ALREADY_EXISTS: <I18n id={i18nKeys.NOTIFICATIONS_EMAIL_ALREADY_EXISTS} />,
  EMPTY_USER_DATA: <I18n id={i18nKeys.NOTIFICATIONS_EMPTY_USER_DATA} />,
  FAILED_TO_CONNECT: network => <I18n id={i18nKeys.NOTIFICATIONS_FAILED_TO_CONNECT} data={{ network }} />,
  FAILED_TO_CONNECT_WITH_SOCIAL: <I18n id={i18nKeys.NOTIFICATIONS_FAILED_TO_CONNECT_WITH_SOCIAL} />,
  FAILED_TO_SAVE_ENTITY: entityName => <I18n id={i18nKeys.NOTIFICATIONS_FAILED_TO_SAVE_ENTITY} data={{ entityName }} />,
  FILE_TYPE_FILE: <I18n id={i18nKeys.NOTIFICATIONS_FILE_TYPE_FILE} />,
  FILE_UPLOAD_EMPTY: <I18n id={i18nKeys.NOTIFICATIONS_FILE_UPLOAD_EMPTY} />,
  FILE_UPLOAD_IN_PROGRESS: <I18n id={i18nKeys.NOTIFICATIONS_FILE_UPLOAD_IN_PROGRESS} />,
  FILE_UPLOAD_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_FILE_UPLOAD_SUCCESS} />,
  FILE_SIZE_EXCEEDED: () => (
    <I18n id={i18nKeys.HIRE_NOTIFICATION_FILE_SIZE_EXCEEDED} data={{ maxFileSizeLabel: '5 Mb' }} />
  ),
  FORGOT_PASSWORD: <I18n id={i18nKeys.NOTIFICATIONS_FORGOT_PASSWORD} />,
  FORM_SUBMITTED_SUCCESSFULLY: <I18n id={i18nKeys.NOTIFICATIONS_FORM_SUBMITTED_SUCCESSFULLY} />,
  FORM_SUBMISSION_FAILED: <I18n id={i18nKeys.NOTIFICATIONS_FORM_SUBMISSION_FAILED} />,
  GOT_YOUR_FEEDBACK: <I18n id={i18nKeys.NOTIFICATIONS_GOT_YOUR_FEEDBACK} />,
  IMAGE_DELETE_FAILED: <I18n id={i18nKeys.NOTIFICATIONS_IMAGE_DELETE_FAILED} />,
  IMAGE_DELETE_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_IMAGE_DELETE_SUCCESS} />,
  IMAGE_TOO_LARGE: <I18n id={i18nKeys.NOTIFICATIONS_IMAGE_TOO_LARGE} />,
  IMAGE_UPLOAD_FAILED: <I18n id={i18nKeys.NOTIFICATIONS_IMAGE_UPLOAD_FAILED} />,
  IMAGE_UPLOADED: <I18n id={i18nKeys.NOTIFICATIONS_IMAGE_UPLOADED} />,
  IMOB_ONBOARDING_ERROR: <I18n id={i18nKeys.NOTIFICATIONS_IMOB_ONBOARDING_ERROR} />,
  IMOB_ACCEPTED_PROPOSAL: <I18n id={i18nKeys.NOTIFICATIONS_IMOB_ACCEPTED_PROPOSAL} />,
  IMPORT_RESUME_FILE_NO_DATA: <I18n id={i18nKeys.NOTIFICATIONS_IMPORT_RESUME_FILE_NO_DATA} />,
  INVALID_APPLY: <I18n id={i18nKeys.NOTIFICATIONS_INVALID_APPLY} />,

  INVALID_CSRF: (
    <I18n
      id={i18nKeys.NOTIFICATIONS_INVALID_CSRF}
      data={{
        reload: (
          <ActionLink onClick={() => location.reload()}>
            <I18n id={i18nKeys.RELOAD} />
          </ActionLink>
        ),
      }}
    />
  ),
  INVALID_FILE_FORMAT: <I18n id={i18nKeys.NOTIFICATIONS_INVALID_FILE_FORMAT} />,
  INVALID_REQUEST: <I18n id={i18nKeys.NOTIFICATIONS_INVALID_REQUEST} />,
  INVALID_REQUEST_OTHER_USER: <I18n id={i18nKeys.NOTIFICATIONS_INVALID_REQUEST_OTHER_USER} />,
  LANGUAGE_ADDED_TO_PROFIlE: language => (
    <I18n id={i18nKeys.NOTIFICATIONS_LANGUAGE_ADDED_TO_PROFIlE} data={{ language }} />
  ),
  LANGUAGE_CHANGED: <I18n id={i18nKeys.NOTIFICATIONS_LANGUAGE_CHANGED} />,
  LANGUAGE_MUST_BE_DIFFERENT: <I18n id={i18nKeys.LANGUAGE_MUST_BE_DIFFERENT} />,

  LINK_EXPIRED: <I18n id={i18nKeys.NOTIFICATIONS_LINK_EXPIRED} />,
  MANAGER_APPLIED_OWN_JOB: <I18n id={i18nKeys.NOTIFICATIONS_MANAGER_APPLIED_OWN_JOB} />,
  MENTOR_REJECTED_MENTEE: <I18n id={i18nKeys.NOTIFICATIONS_MENTOR_REJECTED_MENTEE} />,
  MENTOR_THUMB_UP: firstName => (
    <I18n
      id={firstName ? i18nKeys.NOTIFICATIONS_MENTOR_THUMB_UP_WITH_NAME : i18nKeys.NOTIFICATIONS_MENTOR_THUMB_UP}
      data={{ firstName }}
    />
  ),
  NO_STAFFERS: <I18n id={i18nKeys.NOTIFICATIONS_NO_STAFFERS} />,
  NOT_INTERESTED: <I18n id={i18nKeys.NOTIFICATIONS_NOT_INTERESTED} />,
  OPPORTUNITY_ADDED: (
    <I18n
      id={i18nKeys.NOTIFICATIONS_OPPORTUNITY_ADDED}
      data={{
        strong: chunk => <strong>{chunk}</strong>,
      }}
    />
  ),
  PASSWORD_CHANGED: <I18n id={i18nKeys.NOTIFICATIONS_PASSWORD_CHANGED} />,
  CONNECTION_THUMB_UP: name => <I18n data={{ name }} id={i18nKeys.NOTIFICATIONS_CONNECTION_THUMB_UP} />,
  CONNECTION_REJECTED: name => <I18n id={i18nKeys.NOTIFICATIONS_CONNECTION_REJECTED} data={{ name }} />,

  PIN_FOR_LATER_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_PIN_FOR_LATER_SUCCESS} />,
  PIN_FOR_LATER_ERROR: <I18n id={i18nKeys.NOTIFICATIONS_PIN_FOR_LATER_ERROR} />,
  UNPIN_FOR_LATER_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_UNPIN_FOR_LATER_SUCCESS} />,

  PLEASE_RATE: <i18n id={i18nKeys.NOTIFICATIONS_PLEASE_RATE} />,
  PROFILE_IMPORTED: network => <I18n id={i18nKeys.NOTIFICATIONS_PROFILE_IMPORTED} data={{ network }} />,
  PROPOSAL_ACCEPTED: <I18n id={i18nKeys.NOTIFICATIONS_PROPOSAL_ACCEPTED} />,
  PROPOSAL_DECLINED: <I18n id={i18nKeys.NOTIFICATIONS_PROPOSAL_DECLINED} />,
  PROPOSAL_DECLINED_ERROR: <I18n id={i18nKeys.NOTIFICATIONS_PROPOSAL_DECLINED_ERROR} />,
  REQUEST_ERROR: <I18n id={i18nKeys.NOTIFICATIONS_REQUEST_ERROR} />,
  RESUME_SAVED: <I18n id={i18nKeys.NOTIFICATIONS_RESUME_SAVED} />,
  REFER_FRIEND_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_REFER_FRIEND_SUCCESS} />,
  SAVED: <I18n id={i18nKeys.NOTIFICATIONS_SAVED} />,
  SETTINGS_SAVED: <I18n id={i18nKeys.NOTIFICATIONS_SETTINGS_SAVED} />,
  STUDIO_CO_OWNER_EDIT_LOCKED_ERROR: <I18n id={i18nKeys.STUDIO_CO_OWNER_EDIT_LOCKED_ERROR} />,
  STUDIO_CO_OWNER_DELETE_LOCKED_ERROR: <I18n id={i18nKeys.STUDIO_CO_OWNER_DELETE_LOCKED_ERROR} />,
  INVALID_FILE_CONTENT: <I18n id={i18nKeys.HIRE_NOTIFICATION_FILE_MISSING_DATA} />,
  SKILLS_INTERESTS: <I18n id={i18nKeys.NOTIFICATIONS_SKILLS_INTERESTS} />,
  TO_MANY_LOGIN_ATTEMPTS: <I18n id={i18nKeys.NOTIFICATIONS_TO_MANY_LOGIN_ATTEMPTS} />,
  URL_COPIED_TO_CLIPBOARD: <I18n id={i18nKeys.NOTIFICATIONS_URL_COPIED_TO_CLIPBOARD} />,
  USER_MISSING_PASSWORD: <I18n id={i18nKeys.NOTIFICATIONS_USER_MISSING_PASSWORD} />,
  USER_PASSWORD_INCORRECT: <I18n id={i18nKeys.NOTIFICATIONS_USER_PASSWORD_INCORRECT} />,
  WISHLIST_DECLINED_SUCCESS: <I18n id={i18nKeys.NOTIFICATIONS_WISHLIST_DECLINED_SUCCESS} />,
  WRONG_CREDENTIALS: <I18n id={i18nKeys.NOTIFICATIONS_WRONG_CREDENTIALS} />,
  YOUR_MESSAGE_HAS_BEEN_SENT: <I18n id={i18nKeys.NOTIFICATIONS_YOUR_MESSAGE_HAS_BEEN_SENT} />,
  TRACK_ITEM_REMOVED: item => (
    <I18n
      id={i18nKeys.ACTION_PLAN_TRACK_ITEM_REMOVED_TOAST}
      data={{ item: <I18n id={i18nKeys[item]} capitalizeFirstLetter /> }}
    />
  ),
  TRACK_ITEM_DONE: item => (
    <I18n
      id={i18nKeys.ACTION_PLAN_TRACK_ITEM_DONE_TOAST}
      data={{ item: <I18n id={i18nKeys[item]} capitalizeFirstLetter /> }}
    />
  ),
  TRACK_ITEM_UNDONE: item => (
    <I18n
      id={i18nKeys.ACTION_PLAN_TRACK_ITEM_UNDONE_TOAST}
      data={{ item: <I18n id={i18nKeys[item]} capitalizeFirstLetter /> }}
    />
  ),
  TRACK_ITEM_ADDED: item => {
    return (
      <I18n
        id={i18nKeys.ACTION_PLAN_TRACK_ITEM_ADDED_TOAST}
        data={{ item: <I18n id={i18nKeys[item]} capitalizeFirstLetter /> }}
      />
    );
  },
  FILE_MAX_UPLOADS_EXCEEDED: <I18n id={i18nKeys.HIRE_NOTIFICATION_FILE_MAX_UPLOADS_EXCEEDED} />,
  WITHDRAW_OPP_MODAL_SUCCESS: <I18n id={i18nKeys.WITHDRAW_OPP_MODAL_SUCCESS} />,
  SKILLS_SUGGESTIONS_SUCCESS_TOAST: ({ count, firstName }) => (
    <I18n id={i18nKeys.SKILLS_SUGGESTIONS_SUCCESS_TOAST} data={{ count, firstName }} />
  ),
  ROLES_SUGGESTIONS_SUCCESS_TOAST: ({ count, firstName }) => (
    <I18n id={i18nKeys.ROLES_SUGGESTIONS_SUCCESS_TOAST} data={{ count, firstName }} />
  ),
};
